module.exports = __webpack_public_path__ + "static/media/default_user_img.23aac12f.png";